import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AboutUsPages } from '../models/aboutUs-pages.model';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from 'src/app/shared/i18n/translation.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment.prod';

@Injectable({
    providedIn: 'root',
})

export class AboutUsService extends BaseService<AboutUsPages> {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    API_URL = `${environment.apiUrl}/BasicPages`;
    API_URLGetAll = `${environment.apiUrl}/BasicPages`;

    constructor(@Inject(HttpClient) http, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);

    }

}
